import { LOGIN_FAIL, LOGIN_REQUEST, LOGIN_SUCCESS, ME_REQUEST, ME_SUCCESS } from "../constats/auth.constant";

export const loginReducer = (state={}, action) => {
    switch (action.type) {
        case LOGIN_REQUEST:
            return {
                loading: true
            }    
        case LOGIN_SUCCESS:
            return {
                loading: false
            }    
        case LOGIN_FAIL:
            return {
                loading: false,
                error: action.payload
            }
        default:
            return state;
    }
}

export const authReducer = (state={}, action) => {
    switch (action.type) {
        case ME_REQUEST:
            return {
                loading: true
            }    
        case ME_SUCCESS:
            return {
                loading: false,
                me: action.payload
            }
        default:
            return state;
    }
}